/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Cta_OnlineInputs */

const en_home_hero_cta_online = /** @type {(inputs: Home_Hero_Cta_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use online`)
};

/**
* | output |
* | --- |
* | "Use online" |
*
* @param {Home_Hero_Cta_OnlineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_hero_cta_online = /** @type {((inputs?: Home_Hero_Cta_OnlineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Cta_OnlineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_hero_cta_online(inputs)
});
export { home_hero_cta_online as "home.hero.cta_online" }